export default [
  {
    id: "barrie",
    label: "Barrie",
  },
  {
    id: "belleville",
    label: "Belleville",
  },
  {
    id: "brampton",
    label: "Brampton",
  },
  {
    id: "brantford",
    label: "Brantford",
  },
  {
    id: "brockville",
    label: "Brockville",
  },
  {
    id: "burlington",
    label: "Burlington",
  },
  {
    id: "cambridge",
    label: "Cambridge",
  },
  {
    id: "clarence-rockland",
    label: "Clarence-Rockland",
  },
  {
    id: "cornwall",
    label: "Cornwall",
  },
  {
    id: "dryden",
    label: "Dryden",
  },
  {
    id: "elliot lake",
    label: "Elliot Lake",
  },
  {
    id: "greater sudbury",
    label: "Greater Sudbury",
  },
  {
    id: "guelph",
    label: "Guelph",
  },
  {
    id: "hamilton",
    label: "Hamilton",
  },
  {
    id: "kawartha lakes",
    label: "Kawartha Lakes",
  },
  {
    id: "kenora",
    label: "Kenora",
  },
  {
    id: "kingston",
    label: "Kingston",
  },
  {
    id: "kitchener",
    label: "Kitchener",
  },
  {
    id: "london",
    label: "London",
  },
  {
    id: "markham",
    label: "Markham",
  },
  {
    id: "mississauga",
    label: "Mississauga",
  },
  {
    id: "niagara falls",
    label: "Niagara Falls",
  },
  {
    id: "north bay",
    label: "North Bay",
  },
  {
    id: "oakville",
    label: "Oakville",
  },
  {
    id: "orillia",
    label: "Orillia",
  },
  {
    id: "oshawa",
    label: "Oshawa",
  },
  {
    id: "ottawa",
    label: "Ottawa",
  },
  {
    id: "owen sound",
    label: "Owen Sound",
  },
  {
    id: "pembroke",
    label: "Pembroke",
  },
  {
    id: "peterborough",
    label: "Peterborough",
  },
  {
    id: "pickering",
    label: "Pickering",
  },
  {
    id: "port colborne",
    label: "Port Colborne",
  },
  {
    id: "quinte west",
    label: "Quinte West",
  },
  {
    id: "richmond hill",
    label: "Richmond Hill",
  },
  {
    id: "sarnia",
    label: "Sarnia",
  },
  {
    id: "sault ste. marie",
    label: "Sault Ste. Marie",
  },
  {
    id: "st. catharines",
    label: "St. Catharines",
  },
  {
    id: "st. thomas",
    label: "St. Thomas",
  },
  {
    id: "stratford",
    label: "Stratford",
  },
  {
    id: "temiskaming shores",
    label: "Temiskaming Shores",
  },
  {
    id: "thorold",
    label: "Thorold",
  },
  {
    id: "thunder bay",
    label: "Thunder Bay",
  },
  {
    id: "timmins",
    label: "Timmins",
  },
  {
    id: "toronto",
    label: "Toronto",
  },
  {
    id: "vaughan",
    label: "Vaughan",
  },
  {
    id: "waterloo",
    label: "Waterloo",
  },
  {
    id: "welland",
    label: "Welland",
  },
  {
    id: "windsor",
    label: "Windsor",
  },
  {
    id: "woodstock",
    label: "Woodstock",
  },
];
